/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './ClaimForm.css';

import {
} from '../../actions';


class ClaimForm extends OzFormComponent {

  static fields = [
    'username',
    'email',
    'password',
  ];

  renderBody() {
    let company = this.props.company;
    return (
      <div className="ClaimForm">
        <p>Set a password for your account to claim your listing for <b>{company.name}</b>.</p>
        {this.renderFormGroup('Username', 'text', 'username')}
        {this.renderFormGroup('Email', 'email', 'email')}
        {this.renderFormGroup('Password', 'password', 'password')}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClaimForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ClaimForm.js
 **/